import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getCoreContentTags } from "./actions";

export const coreContentTagsEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity.contentId,
});

const initialState = coreContentTagsEntityAdapter.getInitialState({});

export const coreContentTagsSlice = createSlice({
  name: "coreContentTags",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCoreContentTags.fulfilled, (state, action) => {
      const { data } = action.payload;
      const entities = Object.entries(data).map(([contentId, fields]) => {
        const fieldsTagsByFieldId = fields.reduce((acc, field) => {
          const { fieldId } = field;

          if (!acc[fieldId]) {
            acc[fieldId] = [];
          }
          acc[fieldId].push(field);

          return acc;
        }, {});

        return {
          contentId,
          fieldTags: fieldsTagsByFieldId,
        };
      });
      if (action.meta.arg.upsert) {
        coreContentTagsEntityAdapter.upsertMany(state, entities);
      } else {
        coreContentTagsEntityAdapter.setAll(state, entities);
      }
    });
  },
});

export default coreContentTagsSlice.reducer;
